// Bike-insurance (Bikmo) eligibility logic. Pure + side-effect-free so it can
// be unit-tested without mounting the Svelte widget.
//
// Mirrors the legacy m7_bike_insurance rule: insurance can only be added for
// bikes whose combined value is <= 10.000 €. Above that the section stays
// visible but the checkbox is disabled and a red message explains why.
// Dasselbe gilt bei Fahrradleasing — reference: [1].

export const MAX_INSURANCE_BIKE_PRICE = 10000;

/**
 * @param {{hasBike?: boolean, totalBikePrice?: number, blockedByLeasing?: boolean}|null|undefined} insurance
 * @param {number} max
 * @returns {{hasBike: boolean, total: number, max: number, show: boolean, overLimit: boolean, blockedByLeasing: boolean, canInsure: boolean}}
 */
export function insuranceState(insurance, max = MAX_INSURANCE_BIKE_PRICE) {
    const hasBike = !!insurance?.hasBike;
    const total = Number(insurance?.totalBikePrice ?? 0);
    const overLimit = hasBike && total > max;
    // reference: [1]
    const blockedByLeasing = !!insurance?.blockedByLeasing;
    return {
        hasBike,
        total,
        max,
        // Section is shown whenever the basket contains an insurable bike —
        // even over the limit, so the customer learns why it's unavailable.
        show: hasBike,
        overLimit,
        blockedByLeasing,
        canInsure: hasBike && !overLimit && !blockedByLeasing,
    };
}
